export default {
  OPEN: 'open',
  CLOSE: 'close'
}
